export const useTotalPrice = items => {
  let total = 0
  if (items) {
    for (var i = 0; i < items.length; i++) {
      total += items[i].cost
        ? parseFloat(items[i].cost) * parseInt(items[i].qty)
        : 0
    }
  }

  return total
}

export const useTaxPrice = (tax, totalPrice) => {
  let taxes = {}
  if (tax) {
    for (var i = 0; i < tax.length; i++) {
      taxes[tax[i].name] = tax[i].percentage
        ? (parseFloat(tax[i].percentage) * parseFloat(totalPrice)) / 100
        : 0
    }
  }

  return taxes
}

export const useTotalIncludeTax = (allTax, totalPrice) => {
  const totalTax =
    Object.keys(allTax).length > 0
      ? Object.values(allTax).reduce((a, b) => a + b)
      : 0

  return parseFloat(totalTax) + parseFloat(totalPrice)
}
